import axios from "axios";
import { errorMessages, warningMessages } from "../enums/messages.enum";
import { errorToaster } from "./alert-service";


// const devOrigin: string = "my.ist.edu.pk";
// const devOrigin: string = "my.ist.edu.pk";
// const devOrigin: string = "my.next.edu.pk";
// const devOrigin: string = "lgu.umsoncloud.com";
// const devOrigin: string = "ist.umsoncloud.com";
// const devOrigin: string = "my.ist.edu.pk";
// const devOrigin: string = "ist.umsoncloud.com";
// const devOrigin: string = "my.alkawthar.edu.pk";
// const devOrigin: string = "my.ist.edu.pk";
// const devOrigin: string = "ist.umsoncloud.com";
const devOrigin: string = "eportal.alkawthar.edu.pk";

const isProductionMode =
    process.env.REACT_APP_PRODUCTION_MODE === "true";

const getHeaders = () => {
  const token =
      localStorage.getItem("loginAsToken") ??
      localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
    devOrigin,
  };

  if (isProductionMode || window.location.hostname === "localhost") {
    delete headers.devOrigin;
  }

  return headers;
};

export const postRequest = async (url: string, data: any, params: any = {}, config: any = {}) => {
  try {
    const headers = getHeaders();
    const { skipGlobalToaster, ...queryParams } = params ?? {};
    const response = await axios.post(url, data, {
      params: queryParams,
      headers,
      ...(skipGlobalToaster !== undefined ? { skipGlobalToaster } : {}),
      ...config,
    });
    return response.data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const getRequest = async (
  url: string,
  params: any = {},
  config: any = {},
) => {
  try {
    const headers = getHeaders();
    const response: any = await axios.get(url, { params, headers, ...config });
    return response.data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const putRequest = async (url: string, data: any, params: any = {}) => {
  try {
    const headers = getHeaders();
    const response: any = await axios.put(url, data, { params, headers });
    return response.data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const patchRequest = async (
  url: string,
  data: any,
  params: any = {},
) => {
  try {
    const headers = getHeaders();
    const response: any = await axios.patch(url, data, { params, headers });
    return response.data;
  } catch (error) {
    return errorHandler(error);
  }
};

export const deleteRequest: any = async (url: string, params: any = {}) => {
  try {
    const headers = getHeaders();
    const response = await axios.delete(url, { params, headers });
    return response?.data;
  } catch (error) {
    return errorHandler(error);
  }
};

const errorHandler = (error: any) => {
  let message = "";
  if (error.response) {
    const res = error.response.data;
    if (error.response.status === 401) {
      if (!window.location.pathname.includes("/users/login")) {
        localStorage.setItem("redirect_url", window.location.pathname + window.location.search);
      }
      errorToaster(warningMessages.sessionExpired);
      setTimeout(() => {
        if (!window.location.pathname.includes("/users/login")) {
          window.location.href = "/users/login";
        }
      }, 1000);
    } else if (error.response.status !== 422) {
      if (!error.config?.skipGlobalToaster) {
        errorToaster(errorMessages.somethingWentWrong);
      }
    }
    if (res) {
      message = res.message || res.metadata?.message;
    } else {
      message = JSON.stringify(res);
    }
  } else if (error?.message) {
    message = error.message;
    errorToaster(message);
  }

  return { error: message, errors: error.response?.data?.errors };
};
